module.exports = __webpack_public_path__ + "static/media/sow-section-5-banner.685f4739.svg";